export const MODEL_SPECIFIC_SELECTOR = ["location", "marketing_source", "city", "provincestate", "country", "billing_city",
  "billing_state",
  "billing_zip",
  "billing_country",
  "language"
];

export const MODEL_SELECTOR = [
  "selector1",
  "selector2",
  "selector3",
  "selector4",
  "selector5",
  "selector6",
  "selector7",
  "selector8",
  "selector9",
  "selector10",
  "selector11",
  "selector12",
  "selector13",
  "selector14",
  "selector15",
  "selector16",
  "selector17",
  "selector18",
  "selector19",
  "selector20",
  "selector21",
  "selector22",
  "selector23",
  "selector24",
  "selector25",
  "selector26",
  "selector27",
  "selector28",
  "selector29",
  "selector30",
  "selector31",
  "selector32",
  "selector33",
  "selector34",
  "selector35",
  "text1",
  "text2",
  "text3",
  "text4",
  "text5",
  "text6",
  "text7",
  "text8",
  "text9",
  "text10",
  "text11",
  "text12",
  "text13",
  "text14",
  "text15",
  "text16",
  "text17",
  "text18",
  "text19",
  "text20",
  "text21",
  "text22",
  "text23",
  "text24",
  "text25",
  "text26",
  "text27",
  "text28",
  "text29",
  "text30",
  "text31",
  "text32",
  "text33",
  "text34",
  "text35",
  "text36",
  "text37",
  "text38",
  "text39",
  "text40",
  "text41",
  "text42",
  "text43",
  "text44",
  "text45",
  "text46",
  "text47",
  "text48",
  "text49",
  "text50",
  "text51",
  "text52",
  "text53",
  "text54",
  "text55",
  "text56",
  "text57",
  "text58",
  "text59",
  "text60",
  "text61",
  "text62",
  "text63",
  "text64",
  "text65",
  "text66",
  "text67",
  "text68",
  "text69",
  "text70",
  "currency",
  "provincestate",
  "status",
  // "years_of_experience",
];

export const MODEL_CHILDREN_SELECTOR = [
  "selector1",
  "selector2",
  "selector3",
  "selector4",
  "selector5",
  "selector6",
  "selector7",
  "selector8"
];

export const MODEL_CONTACT_SELECTOR = [
  "selector1",
  "selector2",
  "selector3",
  "selector4",
  "selector5",
];


export const MODEL_MULTI_SELECT = [
  "multiselect1",
  "multiselect2",
  "multiselect3",
  "multiselect4",
  "multiselect5",
  "multiselect6",
  "multiselect7",
  "multiselect8",
  "multiselect9",
  "multiselect10",
  "multiselect11",
  "multiselect12",
  "multiselect13",
  "multiselect14",
  "multiselect15",
  "multiselect16",
  "multiselect17",
  "multiselect18",
  "multiselect19",
  "multiselect20",
  "multiselect21",
  "multiselect22",
  "multiselect23",
  "multiselect24",
  "multiselect25",
  "multiselect26",
  "multiselect27",
  "multiselect28",
  "multiselect29",
  "multiselect30",
  "multiselect31",
  "multiselect32",
  "multiselect33",
  "multiselect34",
  "multiselect35",
  "multiselect36",
  "multiselect37",
  "multiselect38",
  "multiselect39",
  "multiselect40",
  "types",
  "skills",
  "skills2",
  "skills3",
  "sectors",
  "features",
  "features2",
  "preferences",
  "preferences2",
  "preferences3",
  "tags",
  "locations",
];

export const MODEL_SHARE_MULTI_FIELDS = [
  "multiselect1",
  "multiselect2",
  "multiselect3",
  "multiselect4",
  "multiselect5",
  "multiselect6",
  "multiselect7",
  "multiselect8",
  "multiselect9",
  "multiselect10",
  "multiselect11",
  "multiselect12",
  "multiselect13",
  "multiselect14",
  "multiselect15",
  "multiselect16",
  "multiselect17",
  "multiselect18",
  "multiselect19",
  "multiselect20",
  "multiselect21",
  "multiselect22",
  "multiselect23",
  "multiselect24",
  "multiselect25",
  "multiselect26",
  "multiselect27",
  "multiselect28",
  "multiselect29",
  "multiselect30",
  "multiselect31",
  "multiselect32",
  "multiselect33",
  "multiselect34",
  "multiselect35",
  "multiselect36",
  "multiselect37",
  "multiselect38",
  "multiselect39",
  "multiselect40",
  "types",
  "job_types",
  "skills",
  "skills2",
  "skills3",
  "sectors",
  "features",
  "features2",
  "preferences",
  "preferences2",
  "preferences3",
  "tags",
  "locations",
];

export const MODEL_BOOLEAN_SELECTOR = [
  "boolean_selector1",
  "boolean_selector2",
  "boolean_selector3",
  "boolean_selector4",
  "boolean_selector5",
  "boolean_selector6",
  "boolean_selector7",
  "boolean_selector8",
  "boolean_selector9",
  "boolean_selector10",
  "boolean_selector11",
  "boolean_selector12",
  "boolean_selector13",
  "boolean_selector14",
  "boolean_selector15",
  "boolean_selector16",
  "boolean_selector17",
  "boolean_selector18",
  "boolean_selector19",
  "boolean_selector20",
];

export const MODEL_TIME_PICKER = [
  "time1",
  "time2",
  "time3",
  "time4"
];

export const MODEL_FILE_NONE_IMAGE = [
  "resume",
  "transcript",
  "file1",
  "file2",
  "file3",
  "file4",
  "file5",
  "file6",
  "file7",
  "file8",
  "file9",
  "file10",
  "file11",
  "file12",
  "file13",
  "file14",
  "file15",
];

export const MODEL_TEXT = [
  "text1",
  "text2",
  "text3",
  "text4",
  "text5",
  "text6",
  "text7",
  "text8",
  "text9",
  "text10",
  "text11",
  "text12",
  "text13",
  "text14",
  "text15",
  "text16",
  "text17",
  "text18",
  "text19",
  "text20",
  "text21",
  "text22",
  "text23",
  "text24",
  "text25",
  "text26",
  "text27",
  "text28",
  "text29",
  "text30",
  "text31",
  "text32",
  "text33",
  "text34",
  "text35",
  "text36",
  "text37",
  "text38",
  "text39",
  "text40",
  "text41",
  "text42",
  "text43",
  "text44",
  "text45",
  "text46",
  "text47",
  "text48",
  "text49",
  "text50",
  "text51",
  "text52",
  "text53",
  "text54",
  "text55",
  "text56",
  "text57",
  "text58",
  "text59",
  "text60",
  "text61",
  "text62",
  "text63",
  "text64",
  "text65",
  "text66",
  "text67",
  "text68",
  "text69",
  "text70",
  "summary",
  "overview",
  "text_field1",
  "richtext1",
  "richtext2",
  "present_employer",
  "title",
  "about_us",
  "stripe_customer_id",
  // "years_of_experience",
];

export const MODEL_CHILDREN_TEXT = [
  "text1",
  "text2",
  "text3",
  "text4",
  "text5",
  "text6",
  "text7",
  "text8",
  "text9",
  "text10",
  "text11",
  "text12",
  "text13",
  "text14",
  "text15",
  "text16",
  "text17",
  "text18",
  "text19",
  "text20",
];

export const MODEL_CONTACT_TEXT = [
  "text1",
  "text2",
  "text3",
  "text4",
  "text5"
];

export const MODEL_RELATIONSHIP_TEXT = [
  "text1",
  "text2",
  "text3",
  "text4",
  "text5",
  "text6",
  "text7",
  "text8",
  "text9",
  "text10",
  "text11",
  "text12",
];

export const MODEL_PET_TEXT = ["text1", "text2", "text3", "text4", "text5"];

export const MODEL_FILE_ALL = ["profile_pic", ...MODEL_FILE_NONE_IMAGE];

export const MODEL_REFERENCE_FILE = ["reference_document", "file1", "file2"];

export const MODEL_EXPERIENCE_FILE = ["recommendation_letter", "file1", "file2"];

export const MODEL_BOOKING_FILE = ["file1", "file2", "file3", "file4", "file5", "file6", "file7"]

export const MODEL_DATE = ["birthday", "available_date", "date1", "date2", "date3", "date4", "date5"];

export const MODEL_USER_PHONE_FIELD = [
  "phone",
  "phone2",
  "info__custom_phone1",
  "info__custom_phone2",
  "info__custom_phone3",
  "info__custom_phone4",
  "info__custom_phone5",
  "info__custom_phone6",
  "info__custom_phone7",
  "info__custom_phone8",
  "info__custom_phone9",
  "info__custom_phone10",
  "info__custom_phone11",
  "info__custom_phone12",
  "info__custom_phone13",
  "info__custom_phone14",
  "info__custom_phone15",
]

export const MODEL_SPECIFIC_TEXT = [
  "email",
  "email2",
  "first_name",
  "middle_name",
  "last_name",
  "name",
  "employer_name", // Used for family names
  "secondary_first_name",
  "secondary_last_name",
  "address1",
  "address2",
  "city",
  "postal_code",
  "provincestate",
  "country",
  "billing_first_name",
  "billing_last_name",
  "billing_address",
  "billing_city",
  "billing_state",
  "billing_zip",
  "billing_country",
  "marketing_source",
  "how_did_you_hear",
  "government_ID_number",
  "social_security",
  "summary",
  "salary_range",
  "facebook",
  "linkedin",
  "twitter",
  "education_institution",
  "degree",
  "diploma",
  "description",
  "present_employer",
  "title",
  "about_us",
  "promo_code",
  "currency",
  "rate",
  "language",
  ...MODEL_USER_PHONE_FIELD
];

export const MODEL_REFERENCE_TEXT = [
  "text1",
  "text2",
  "text3",
  "text4",
  "text5",
  "text6",
  "text7",
  "text8",
  "text9",
  "text10"
];

export const MODEL_REFERENCE_SELECTOR = [
  "selector1",
  "selector2",
  "selector3",
  "selector4",
  "selector5"
];

export const MODEL_REFERENCE_MULTISELECT = [
  "multiselect1",
  "multiselect2",
  "multiselect3",
  "multiselect4",
  "multiselect5",
];

export const MODEL_EXPERIENCE_SELECTOR = [
  "selector1",
  "selector2",
  "selector3",
]

export const MODEL_REFERENCE_SPECIFIC_TEXT = [
  "reference_note",
  "reference_shareable_note",
  "contact_history",
  "company",
  "email",
  "first_name",
  "last_name",
  // "name",
  "phone",
  "phone2",
  "relationship",
  "title",
  "children",
  "city",
  "compensation",
  "country",
  "provincestate",
  "reason_ended",
  "note",
  "person_worked_for_name",
  "address1",
  "address2",
  "postal_code",
  "current_role",
  "status"
];

export const MODEL_REFERENCE_DATE = [
  "start_date",
  "end_date",
]

export const MODEL_EXPERIENCE_TEXT = [
  "text1",
  "text2",
  "text3",
  "text4",
  "text5",
  "text6",
  "text7",
  "text8",
  "text9"
];

export const MODEL_CONTACT_SPECIFIC_TEXT = [
  "user_name",
  "first_name",
  "last_name",
  "phone",
  "phone2",
  "email",
  "type",
  "organization",
  "title",
  "relationship",
  "note",
  "address1",
  "address2",
  "city",
  "postal_code",
  "provincestate",
  "country",
];

export const MODEL_EXPERIENCE_SPECIFIC_TEXT = [
  "experience_verification_note",
  "experience_verification_shareable_note",
  "experience_verification_contact_history",
  "children",
  "city",
  "company_name",
  "compensation",
  "country",
  "employment_type",
  "provincestate",
  "reason_ended",
  "title",
  "note",
  "person_worked_for_name",
  "phone",
  "email",
  "address1",
  "address2",
  "postal_code",
  "current_role",
  "start_date_text",
  "end_date_text",
];

export const MODEL_EXPERIENCE_DATE = [
  "start_date",
  "end_date",
]

export const MODEL_EXPERIENCE_MULTISELECT = [
  "tasks_performed",
  "ages_worked_with",
  "multiselect1",
  "multiselect2",
  "multiselect3",
  "multiselect4",
  "multiselect5",
  "types"
];

// EDUCATION ----

export const MODEL_EDUCATION_SPECIFIC_TEXT = [
  "area_of_study",
  "institution",
  "institution_type",
  "note",
  "grade",
  "degree",
  "country",
  "city",
  "provincestate",
  "start_date_text",
  "end_date_text",
  "text1",
  "text2",
  "text3",
];

export const MODEL_EDUCATION_SELECTOR = ["institution_type", "graduated"];

export const MODEL_EDUCATION_DATE = ["start_date", "end_date"];

// CHILDREN ----

export const MODEL_CHILDREN_SPECIFIC_TEXT = [
  "first_name",
  "middle_name",
  "last_name",
  "name",
  "age",
  "gender",
  "personality_interests",
  "schedule",
  "special_needs",
];

// PET ----

export const MODEL_PET_SPECIFIC_TEXT = ["description", "name", "size", "breed"];

export const MODEL_PET_SPECIFIC_SELECTOR = ["breed", "careExpected", "type"];

// Address ----

export const MODEL_ADDRESS_SPECIFIC_TEXT = [
  "address1",
  "address2",
  "postal_code",
  "city",
  "provincestate",
  "country",
  "notes",
];

export const MODEL_ADDRESS_SELECTOR = [
  "selector1",
  "selector2",
  "selector3",
  "selector4",
  "selector5"
];

export const MODEL_ADDRESS_TEXT = [
  "text1",
  "text2",
  "text3",
  "text4",
  "text5"
];

export const MODEL_CHILDREN_DATE = ["birthday"];

export const MODEL_BOOKING_TIME_PICKER = ["start_time", "end_time"];

export const MODEL_BOOKING_DATE = ["date", "end_date", "date_revenue_generate"];

export const MODEL_BOOKING_SELECTOR = [
  "selector1",
  "selector2",
  "selector3",
  "selector4",
  "selector5",
  "selector6",
  "selector7",
  "selector8",
  "selector9",
  "is_out_of_town",
  "hide_from_job_board",
  "visible_to_candidates",
  "sick_children",
  "skip_charge",
  "timezone"
];

export const MODEL_BOOKING_TEXT = [
  "text",
  "text2",
  "text3",
  "text4",
  "text5",
  "text6",
  "text7",
  "text8",
  "text9",
  "text10",
  "text11",
  "text12",
  "text13",
  "text14",
  "text15",
  "description",
  "admin_notes",
  "dispute_note",
  "candidate_dispute_notes",
  "compensation_type",
  "compensation",
  "children_description",
  "cancel_reason",
  "category",
  "special_instructions",
  "address1",
  "address2",
  "postal_code",
  "city",
  "provincestate",
  "country",
  "location",
  "travel_fee",
  "candidate_rate",
  "client_rate",
  "agency_fee",
  "revenue"
];

export const MODEL_BOOKING_MULTISELECT = [
  "multiselect1",
  "multiselect2",
  "multiselect3",
  "multiselect4",
  "checklist",
  "logistic_requirements",
  "locations",
  "types"
]

// FILE ADDITIONAL INFORMATIOn
export const MODEL_FILE_INFO_DATE = ["expiry"];
export const MODEL_FILE_INFO_SELECTOR = [
  "selector1",
  "selector2",
  "selector3",
  "selector4",
];
export const MODEL_FILE_INFO_SPECIFIC_TEXT = ["note"];

// Reference check form
export const MODEL_REFERENCE_CHECK_MULTISELECT = [
  "check_multiselect1",
  "check_multiselect2",
  "check_multiselect3",
  "check_multiselect4",
  "check_multiselect5",
  "check_multiselect6",
  "check_multiselect7",
  "check_multiselect8",
  "check_multiselect9",
  "check_multiselect10",
];

export const MODEL_REFERENCE_CHECK_SELECTOR = [
  "check_selector1",
  "check_selector2",
  "check_selector3",
  "check_selector4",
  "check_selector5",
  "check_selector6",
  "check_selector7",
  "check_selector8",
  "check_selector9",
  "check_selector10",
]

export const MODEL_REFERENCE_CHECK_TEXT = [
  "check_text1",
  "check_text2",
  "check_text3",
  "check_text4",
  "check_text5",
  "check_text6",
  "check_text7",
  "check_text8",
  "check_text9",
  "check_text10",
  "check_text11",
  "check_text12",
  "check_text13",
  "check_text14",
  "check_text15",
  "check_text16",
  "check_text17",
  "check_text18",
  "check_text19",
  "check_text20",
  "check_text21",
  "check_text22",
  "check_text23",
  "check_text24",
  "check_text25",
  "check_text26",
  "check_text27",
  "check_text28",
  "check_text29",
  "check_text30",
  "check_text31",
  "check_text32",
  "check_text33",
  "check_text34",
  "check_text35",
  "check_text36",
  "check_text37",
  "check_text38",
  "check_text39",
  "check_text40",
  "check_text41",
  "check_text42",
  "check_text43",
  "check_text44",
  "check_text45",
  "check_completion_date_text",
]

export const MODEL_INTEGER_FIELD = [
  "integer1",
  "integer2",
]

export const MODEL_FLOAT_FIELD = [
  "user_latitude",
  "user_longitude"
]


// WEBPACK FOOTER //
// ./src/constants/model-by-types.js